import * as brainTreeBrowserDetection from '@braintree/browser-detection';
import { FilterStartingWith } from '@epicuro-next/utilities';

type BrainTreeBrowserDetection = typeof brainTreeBrowserDetection;
type BrainTreeBrowserDetectionMethods = keyof BrainTreeBrowserDetection;

export type BrowserDetectionMethod = FilterStartingWith<
  BrainTreeBrowserDetectionMethods,
  'is'
>;

export function detectBrowser(
  method: BrowserDetectionMethod,
  userAgent?: string | undefined,
): boolean {
  if (method === 'isEdge') {
    // The NPM package braintree/browser-detection has a bug. It does not detect 'Edg/' as Edge.
    // Hence this wrapper method including 'Edg/'.
    // See issue https://github.com/braintree/browser-detection/issues/41 which has been logged on 2022-08-08 and not fixed as of 2023-04-24.
    return (
      brainTreeBrowserDetection.isEdge(userAgent) ||
      (userAgent ?? navigator.userAgent).indexOf('Edg/') !== -1
    );
  }

  return brainTreeBrowserDetection[method](userAgent);
}
